import React from "react";
import {
  DefaultRouteParam,
  RouteConfig,
} from "../../../../config/router/router.config";

export type OrganizationCreateRouteParam = DefaultRouteParam;

export const organizationCreateRoute: RouteConfig = {
  name: "Create Organization",
  Component: React.lazy(() => import("./OrganizationCreate.view")),
  path: "/organization/create",
  isPrivate: true,
};
